import { HOME_URL } from '@/constants/urls';
import { DBOO } from './paths';

const URL = HOME_URL + DBOO;
const TITLE = 'Opt Out for Free From Junk Mailers, Marketing Data Brokers';
const DESCRIPTION =
  'Aura lowers your risk of spam, scams, and even identity theft by automating opt-out requests from data broker sites on your behalf. Free one-time scan inside.';
const PREVIEW_IMAGE = `${HOME_URL}/dboo_preview.png`;

export const DBOO_META_TAGS = [
  { title: TITLE },
  {
    name: 'description',
    content: DESCRIPTION,
  },
  // general
  { property: 'og:url', content: URL },
  { property: 'og:type', content: 'website' },
  { property: 'og:title', content: TITLE },
  { property: 'og:description', content: DESCRIPTION },
  { property: 'og:image', content: PREVIEW_IMAGE },
  // twitter
  { name: 'twitter:url', content: URL },
  { name: 'twitter:title', content: TITLE },
  { name: 'twitter:description', content: DESCRIPTION },
  { name: 'twitter:image', content: PREVIEW_IMAGE },
  { name: 'twitter:card', content: 'summary_large_image' },
];
